import { RootCodeState } from '@dtx-company/inter-app/src/redux/types'
import { useCodeSelector } from '@dtx-company/inter-app/src/hooks/useCodeSelector'

export const useCreateInFolderPath = (): string | undefined => {
  const { createInFolderPath } = useCodeSelector(
    (state: RootCodeState) => state.unifiedAssetManagement
  )
  return createInFolderPath
}
